<script lang="ts">
  import { Col } from "sveltestrap";
  import { CardFooter, CardWithFooter, CardWithFootercontent } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
</script>
<Col sm="12" xl="6">
    <Card cardProps="height-equal" cardHeaderprops="pb-0" headerTitle={CardWithFooter}>
      <div slot="contentbody">
        <p>{CardWithFootercontent}</p>
      </div>
      <div slot="contentfooter">
        <h6 class="mb-0">{CardFooter}</h6>
      </div>
    </Card>
</Col>